var Webflow = Webflow || [];
Webflow.push(function () {
  $(".nav-button").on("click", function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $("body").removeClass("no-scroll");
    } else {
      $(this).addClass("open");
      $("body").addClass("no-scroll");
    }
    mobileNav();
  });

  function mobileNav() {
    if ($(".nav--mobile .header-menu").hasClass("open")) {
      $(".nav--mobile .header-menu").removeClass("open");
      $("html").removeClass("no-scroll");
      $(".site-header").removeClass("scroll");
    } else {
      $(".nav--mobile .header-menu").addClass("open");
      $("html").addClass("no-scroll");
      $(".site-header").addClass("scroll");
    }
    $(".nav--mobile .main-menu li.mobile-menu-item").each(function (i) {
      $(this)
        .delay(100 * i)
        .fadeIn(500);
    });
  }

  // Mobile Subnav

  $(".mobile-menu-item a").on("click", function () {
    $(this).next().addClass("open");
    const animateChildren = $(this).next().find(".child-links-wrapper li");
    const getChildHeight = $(".main-menu-dropdown.open .wrapper").outerHeight();
    $(".header-menu.nav-wrapper.open").addClass("sub-nav-open");
    $(".sub-nav-open").css("min-height", getChildHeight);
    setTimeout(function () {
      $(animateChildren).each(function (i) {
        $(this)
          .delay(75 * i)
          .addClass("reveal");
      });
    }, 100);
  });

  $(".nav-back-link").on("click", function () {
    $(this).closest(".main-menu-dropdown").removeClass("open");
    $(".header-menu.nav-wrapper.open").removeClass("sub-nav-open");
    $(".header-menu.nav-wrapper").css("min-height", "");
    $(".open .child-links-wrapper li").removeClass("reveal");
  });

  function animateSubLinks(children) {
    $(children).each(function (i) {
      $(this)
        .delay(75 * i)
        .fadeIn(500);
    });
  }

  function noMoreLonelyWords(selector, numWords) {
    // Get array of all the selected elements
    var elems = document.querySelectorAll(selector);
    var i;
    for (i = 0; i < elems.length; ++i) {
      // Split the text content of each element into an array
      var textArray = elems[i].innerText.split(" ");

      // Remove the last n words and join them with a none breaking space
      var lastWords = textArray.splice(-numWords, numWords).join("&nbsp;");

      // Join it all back together and replace the existing
      // text with the new text
      var textMinusLastWords = textArray.join(" ");
      elems[i].innerHTML = textMinusLastWords + " " + lastWords;
    }
  }

  var isMobile = window.matchMedia("only screen and (max-width: 991px)");

  if (isMobile.matches) {
  } else {
    // noMoreLonelyWords(".page-info .default-text span", 7);
    // noMoreLonelyWords(".page-info .default-text p", 7);
  }

  // 	var isMobile = window.matchMedia("only screen and (max-width: 767px)");
  //
  // 	if (isMobile.matches) {
  // 		// Scroll Scripts
  // 		// Hide Header on on scroll down
  // 		var didScroll;
  // 		var lastScrollTop = 0;
  // 		var position = $(window).scrollTop();
  // 		var delta = 5;
  // 		var $nav = $(".floating-header");
  // 		var navbarHeight = $(".floating-header").outerHeight();
  // 		var winH = $(window).height();
  //
  // 		$(window).scroll(function (event) {
  // 			didScroll = true;
  // 		});
  //
  // 		setInterval(function () {
  // 			if (didScroll) {
  // 				hasScrolled();
  // 				didScroll = false;
  // 			}
  // 		}, 250);
  //
  // 		function hasScrolled() {
  // 			var st = $(this).scrollTop();
  // 			if (Math.abs(lastScrollTop - st) <= delta) return;
  // 			if (st > lastScrollTop && st > navbarHeight) {
  // 				// Scroll Down
  // 				$nav.removeClass("show");
  // 			} else {
  // 				// Scroll Up
  // 				if (st + $(window).height() < $(document).height()) {
  // 					if ($(this).scrollTop() > winH) {
  // 						var scroll = $(window).scrollTop();
  // 						if (scroll > position) {
  // 							$nav.removeClass("show");
  // 						} else {
  // 							$nav.addClass("show");
  // 						}
  // 					} else {
  // 						$nav.removeClass("show");
  // 					}
  // 				}
  // 			}
  //
  // 			lastScrollTop = st;
  // 		}
  // 	}
  //
  // 	var isMobile = window.matchMedia("only screen and (max-width: 767px)");
  //
  // 	if (isMobile.matches) {
  // 		$(window).scroll(function () {
  // 			var scroll = $(window).scrollTop();
  // 			if (scroll > position) {
  // 				setTimeout(function () {
  // 					hideMobileNav();
  // 				}, 500);
  // 			} else {
  // 				setTimeout(function () {
  // 					hideMobileNav();
  // 				}, 500);
  // 			}
  // 			position = scroll;
  // 		});
  // 	}
  //
  // 	function hideMobileNav() {
  // 		// $("a.nav-link.donate, .button.donate").removeClass("open-donate");
  // 		$(".donate-box").removeClass("slide-down");
  // 		setTimeout(function () {
  // 			$(".sub-child").removeClass("fade-in");
  // 		}, 300);
  // 	}
});
